export const FETCHED_TASK_DETAILS_SUCCESSFULLY = "FETCHED_TASK_DETAILS_SUCCESSFULLY";
export const FETCHED_TASKS_SUCCESSFULLY = "FETCHED_TASKS_SUCCESSFULLY";
export const FETCHED_PARTNERS_SUCCESSFULLY = "FETCHED_TASKS_SUCCESSFULLY";
export const VERIFY_ADDRESS_SUCCESSFULLY = "VERIFY_ADDRESS_SUCCESSFULLY";
export const CREATED_APPOINTMENT_SUCCESSFULLY = "CREATED_APPOINTMENT_SUCCESSFULLY";
export const SET_ADDRESS = "SET_ADDRESS";
export const UPDATE_DYNAMIC_ANSWERS = "UPDATE_DYNAMIC_ANSWERS";
export const UPDATE_DESCRIPTION = "UPDATE_DESCRIPTION";
export const UPDATE_CONSUMER = "UPDATE_CONSUMER";
export const FETCH_CONSUMERS_LIST = "FETCH_CONSUMERS_LIST";
export const CLEAR_CONSUMER = "CLEAR_CONSUMER";
export const UPDATE_CONSUMER_DATA = "UPDATE_CONSUMER_DATA";
export const SET_APPOINTMENT_DATES = "SET_APPOINTMENT_DATES";
export const SET_VALIDATION_ERRORS = "SET_VALIDATION_ERRORS";
export const SET_COUPON_CODE = "SET_COUPON_CODE";
export const SET_WARRANTY_PACKAGE = "SET_WARRANTY_PACKAGE";
export const SET_AVAILABLE_RATES = "SET_AVAILABLE_RATES";
export const SET_ASSIGNMENT = "SET_ASSIGNMENT";
export const RESET_DEFAULT = "RESET_DEFAULT";
export const SET_COUPON_ERROR = "SET_COUPON_ERROR";
export const SET_COUPON_SUCSESS = "SET_COUPON_SUCSESS";
export const SET_TASK_ID = "SET_TASK_ID";
export const FETCHED_TASK_DYNAMIC_FIELDS_SUCCESSFULLY = "FETCHED_TASK_DYNAMIC_FIELDS_SUCCESSFULLY";
